/* ============================================================
 * nv-pdp-fit.js - padrao de imagem de produto na pagina de produto
 * Mede onde o produto esta dentro da foto (ignora fundo branco ou
 * transparente) e reposiciona a imagem para que todo produto ocupe a
 * mesma area util do quadro, apoiado na mesma linha de chao. No kit,
 * compoe os itens lado a lado na proporcao real das embalagens.
 * Atua so na galeria da pagina de produto. Se a leitura falhar, o CSS
 * (object-fit: contain) segue valendo.
 * ============================================================ */
(function () {
  var SIDE = 0.08;
  var SAFE_W = 0.84;
  var SAFE_H = 0.80;
  var FLOOR = 0.90;
  var PROBE = 120;
  var WHITE = 236;
  var KIT_GAP = 0;
  var ROOT = '.nv-pdp-gallery';

  function measure(probe) {
    var nw = probe.naturalWidth, nh = probe.naturalHeight;
    if (!nw || !nh) return null;
    var sc = PROBE / Math.max(nw, nh);
    var cw = Math.max(1, Math.round(nw * sc));
    var ch = Math.max(1, Math.round(nh * sc));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(probe, 0, 0, cw, ch);
    var d = ctx.getImageData(0, 0, cw, ch).data;
    var l = cw, t = ch, r = -1, b = -1, alfa = false;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        var i = (y * cw + x) * 4;
        if (d[i + 3] < 20) { alfa = true; continue; }
        if (d[i] > WHITE && d[i + 1] > WHITE && d[i + 2] > WHITE) continue;
        if (x < l) l = x;
        if (x > r) r = x;
        if (y < t) t = y;
        if (y > b) b = y;
      }
    }
    if (r < 0) return null;
    return { ar: nw / nh, bl: l / cw, bt: t / ch, bw: (r - l + 1) / cw, bh: (b - t + 1) / ch, alfa: alfa };
  }

  function apply(img, m) {
    if (!m || m.bw < 0.05 || m.bh < 0.05) return;
    var s0 = img.style;
    /* foto cheia (ambientada, quadrada): centralizada no quadro, no maior tamanho possivel */
    if (!m.alfa && m.bw > 0.85 && m.bh > 0.85) {
      s0.inset = '0';
      s0.left = '0'; s0.top = '0';
      s0.width = '100%'; s0.height = '100%';
      s0.maxWidth = 'none';
      s0.padding = '0';
      s0.objectFit = 'cover';
      s0.objectPosition = 'center center';
      img.classList.add('nv-fit', 'nv-fit-foto');
      return;
    }
    var box = img.closest('.nv-p-img');
    var ca = 1;
    if (box && box.clientHeight) ca = box.clientWidth / box.clientHeight;
    var wd = Math.min(SAFE_W / m.bw, SAFE_H * m.ar / (ca * m.bh));
    var hd = wd * ca / m.ar;
    var left = SIDE + (SAFE_W - wd * m.bw) / 2 - m.bl * wd;
    var top = FLOOR - (m.bt + m.bh) * hd;
    var s = img.style;
    s.inset = 'auto';
    s.left = (left * 100) + '%';
    s.top = (top * 100) + '%';
    s.width = (wd * 100) + '%';
    s.height = (hd * 100) + '%';
    s.maxWidth = 'none';
    s.padding = '0';
    s.objectFit = 'fill';
    img.classList.add('nv-fit');
  }

  function fit(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.dataset.nvFitSrc === src) return;
    img.dataset.nvFitSrc = src;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var m = measure(probe);
        img._nvM = m;
        apply(img, m);
        var box = img.closest('.nv-p-img');
        if (box && 'ResizeObserver' in window && !box._nvRO) {
          box._nvRO = new ResizeObserver(function () { if (img._nvM) apply(img, img._nvM); });
          box._nvRO.observe(box);
        }
      } catch (e) { /* sem CORS: fica o CSS */ }
    };
    probe.src = src;
  }

  function watch(img) {
    if (img.dataset.nvFitBound) return;
    img.dataset.nvFitBound = '1';
    img.addEventListener('load', function () { fit(img); });
    if (img.complete && img.naturalWidth) fit(img);
  }

  function load(src) {
    return new Promise(function (res) {
      var pr = new Image();
      pr.crossOrigin = 'anonymous';
      pr.onload = function () { try { res(measure(pr)); } catch (e) { res(null); } };
      pr.onerror = function () { res(null); };
      pr.src = src;
    });
  }

  function kit(box) {
    if (box.dataset.nvKit) return;
    box.dataset.nvKit = '1';
    var imgs = Array.prototype.slice.call(box.querySelectorAll('img.nv-kit-item'));
    if (imgs.length < 2 || !window.Promise) return;
    Promise.all(imgs.map(function (im) { return load(im.currentSrc || im.src); })).then(function (ms) {
      for (var i = 0; i < ms.length; i++) if (!ms[i] || ms[i].bw < 0.05 || ms[i].bh < 0.05) return;
      var frame = box.closest('.nv-p-img');
      function layout() {
      var ca = (frame && frame.clientHeight) ? frame.clientWidth / frame.clientHeight : 1;
      var list = imgs.map(function (im, i) {
        var m = ms[i];
        return { img: im, m: m, h: parseFloat(im.dataset.h) || 10, pa: m.bw * m.ar / m.bh };
      });
      list.sort(function (a, b) { return b.h - a.h; });
      var row = [];
      list.forEach(function (it, i) { if (i % 2) row.unshift(it); else row.push(it); });
      var maxH = 0, sumW = 0;
      row.forEach(function (it) { maxH = Math.max(maxH, it.h); sumW += it.h * it.pa / ca; });
      var gaps = KIT_GAP * (row.length - 1);
      var u = Math.min(SAFE_H / maxH, (SAFE_W - gaps) / sumW);
      var total = sumW * u + gaps;
      var x = SIDE + (SAFE_W - total) / 2;
      row.forEach(function (it) {
        var H = it.h * u;
        var W = H * it.pa / ca;
        var wImg = W / it.m.bw;
        var hImg = H / it.m.bh;
        var s = it.img.style;
        s.left = ((x - it.m.bl * wImg) * 100) + '%';
        s.top = ((FLOOR - (it.m.bt + it.m.bh) * hImg) * 100) + '%';
        s.width = (wImg * 100) + '%';
        s.height = (hImg * 100) + '%';
        x += W + KIT_GAP;
      });
      box.classList.add('nv-kit-fitted');
      }
      layout();
      if (frame && 'ResizeObserver' in window) new ResizeObserver(layout).observe(frame);
    });
  }

  function start() {
    var roots = document.querySelectorAll(ROOT);
    for (var r = 0; r < roots.length; r++) {
      var imgs = roots[r].querySelectorAll('.nv-p-img img:not(.nv-kit-item)');
      for (var i = 0; i < imgs.length; i++) watch(imgs[i]);
      var kits = roots[r].querySelectorAll('.nv-p-kit');
      for (var k = 0; k < kits.length; k++) kit(kits[k]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
